import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { 
    IonLabel, IonNote, IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvDateService } from '@marv/services';
import { MarvItemComponent, MarvTagComponent, MarvButtonComponent, MarvRatingComponent } from '@marv/components';
import { MissionItem, RetailerLogo, RetailerLogoComponent } from '@app/components';
import { MissionTypeService, CustomerFeedbackService } from '@app/services';
import { EpochToStringPipe } from '@app/pipes';

@Component({
    selector: 'app-mission-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [
        IonLabel, IonNote, IonIcon, TranslatePipe, 
        forwardRef(() => MarvItemComponent), forwardRef(() => MarvTagComponent), forwardRef(() => MarvButtonComponent), 
        forwardRef(() => MarvRatingComponent), EpochToStringPipe, forwardRef(() => RetailerLogoComponent)
    ]
})
export class MissionItemComponent  implements OnInit {

    @Input({alias : 'mission', required : true}) mission: MissionItem;
    @Input({alias : 'displayDay', required : false}) displayDay: boolean = true;
    @Input({alias : 'displayHour', required : false}) displayHour: boolean = true;
    @Input({alias : 'displayProfil', required : false}) displayProfil: boolean = false;
    @Input({alias : 'displayReport', required : false}) displayReport: boolean = true;
    @Input({alias : 'displayEvaluation', required : false}) displayEvaluation: boolean = false;
    @Input({alias : 'displayBtnAddEvaluation', required : false}) displayBtnAddEvaluation: boolean = false;
    @Input({alias : 'displayStatus', required : false}) displayStatus: boolean = true;
    @Output() onSelectMission = new EventEmitter<MissionItem>();
    @Output() onEvaluateMission = new EventEmitter<MissionItem>();
    
    maxRating: number = 0;
    today: number = MarvDateService.GetToday();
    
    constructor(
        public missionTypeService: MissionTypeService
    ) { }

    ngOnInit() {
        this.maxRating = CustomerFeedbackService.CustomerFeedBackValues.length;   
    }
    
    getRetailerLogo(): RetailerLogo{
        return new RetailerLogo(this.mission.retailer.name);
    }

    selectMission(){
        this.onSelectMission.emit(this.mission);        
    }
    
    evaluateMission($event: any){
        if(this.displayBtnAddEvaluation){
            $event.stopPropagation();     
        }   
        this.onEvaluateMission.emit(this.mission);      
    }
}
